import React, { lazy, StrictMode, Suspense } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SignUpPageHeader } from '@mobi/account/Areas/SignUp/Components'
import type { Campaign } from '@mobi/account/Areas/SignUp'
import { Spinner } from '@mobi/component-library/Common/Spinner'
import { MainContainer } from '@core/Components/Containers'
import { useObservableImmutable } from '@core/Utils/hooks'
import { trackOptimoveEvent } from '@core/Services/Optimove/optimove'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { attemptLogin, showLogin } from '@core/Areas/Login/helpers'
import { openDeposit } from '@core/Areas/Deposit'
import { useDisableAppHeaderRender } from '@core/Areas/AppHeader/hooks/useDisableAppHeaderRender'
import { getIsReloadPending } from '@core/Areas/Kambi/Store/selectors'
import { setIsInSignUp, setIsReloadPending } from '@core/Areas/Kambi/Store'

const SignUpPage = lazy(() => import('@mobi/account/Areas/SignUp/Components/SignUpPage'))

export const SignUp = () => {
  const dispatch = useDispatch()
  const isReloadPending = useSelector(getIsReloadPending)
  useDisableAppHeaderRender()
  const { isLoggedIn } = useObservableImmutable(userAccountState$, ['isLoggedIn'])
  const availableCampaigns = useObservableImmutable(userAccountState$, ['campaigns']).campaigns
  const firstLiveCampaign: Campaign | undefined = availableCampaigns?.find(x => x.isLive)

  return (
    <StrictMode>
      <Suspense fallback={<Spinner key='signup-loader' />}>
        <SignUpPageHeader />
        <MainContainer data-tid-sign-up background='white'>
          <SignUpPage
            isLoggedIn={isLoggedIn}
            attemptLogin={attemptLogin}
            showLogin={showLogin}
            campaign={firstLiveCampaign}
            openDeposit={openDeposit}
            trackOptimoveEvent={trackOptimoveEvent}
            onMount={() => {
              dispatch(setIsInSignUp(true))
            }}
            onDispose={() => {
              dispatch(setIsInSignUp(false))
              if (isReloadPending) {
                dispatch(setIsReloadPending(false))
                window.location.reload()
              }
            }}
          />
        </MainContainer>
      </Suspense>
    </StrictMode>
  )
}
